module.exports = __webpack_public_path__ + "img/forest-fire.847e6e7c.jpg";